const translations = {
  "en": {
    "How can we do better?": "How can we do better?",
    "Please let us know how we can enhance Edgen for you.": "Please let us know how we can enhance Ed for you."
  },
  "zh-tw": {
    "How can we do better?": "我們如何做得更好？",
    "Please let us know how we can enhance Edgen for you.": "請告訴我們你希望我們如何把 Ed 做得更好。"
  }
};

export default translations;
